import { Component, computed, input, output } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { AvatarComponent } from '../avatar/avatar.component';
import type { CommentAttachmentLink, CommentHyperlink } from './comment.interfaces';

@Component({
  selector: 'ocp-comment',
  templateUrl: './comment.component.html',
  styleUrl: './comment.component.scss',
  imports: [TranslatePipe, DatePipe, AvatarComponent],
})
export class CommentComponent {
  readonly message = input.required<string>();
  readonly displayName = input('');
  readonly date = input('');
  readonly isAuthor = input(false);
  readonly showCloseButton = input(false);
  readonly colorSeed = input<string | undefined>(undefined);
  readonly hyperlinks = input<CommentHyperlink[]>([]);
  readonly attachmentLinks = input<CommentAttachmentLink[]>([]);

  readonly commentClose = output<void>();

  protected readonly userInitials = computed(() =>
    this.displayName()
      .split(' ')
      .filter(Boolean)
      .slice(0, 2)
      .map(n => n[0].toUpperCase())
      .join('')
  );

  protected onCloseClick(): void {
    this.commentClose.emit();
  }

  protected onCloseKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.commentClose.emit();
    }
  }
}
